import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { rejectBatchEnrollmentInvitation, resetRejectBatchEnrollmentInvitation } from "./reject-batch-enrollment-invitation";

const initialState: ProcessingState = { processing: "idle" };

export const rejectBatchEnrollmentInvitationReducer = createReducer<ProcessingState>(initialState, builder => {
  builder
    .addCase(rejectBatchEnrollmentInvitation.pending, state => ({ ...state, processing: "pending" }))
    .addCase(rejectBatchEnrollmentInvitation.fulfilled, state => ({ ...state, processing: "success" }))
    .addCase(rejectBatchEnrollmentInvitation.rejected, state => ({ ...state, processing: "failed" }))
    .addCase(resetRejectBatchEnrollmentInvitation, () => initialState);
});
